<template>
<div :class="classes" v-if="data && data.length">
	<Heading :level="2" classes="minr-h5" text="Previously uploaded files" />

	<ul class="upload-list cols-full">
		<li v-for="(uploaded, index) in data" :key="index" class="flex align-center">
			<component :is="getFileIcon(uploaded.documentbody)" classes="minr-icon_sml m-r-05" />
			{{ uploaded.filename || uploaded.subject }}
		</li>
	</ul>
</div>
</template>

<script>

export default {
	name: 'FileUpload',
	props: {
		data: {
			type: Array,
			default () {
				return [];
			}
		},
		classes: {
			type: String,
			default: ''
		}

	},
	data () {
		return {

		};
	},
	methods: {
		getFileIcon (content) {
			if (!content) {
				return 'FileIcon';
			}
			const type = content.charAt(0);
			let icon = '';
			switch (type) {
			case 'i': case '/': case 'R':
				icon = 'ImageIcon';
				break;
			case 'J':
				icon = 'PdfIcon';
				break;
			default:
				icon = 'FileIcon';
			}
			return icon;
		}

	}
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/components/uploadList.scss';

</style>
